import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { FaArrowLeft } from 'react-icons/fa';
import './Login.css';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const response = await axios.post('/auth/forgot-password', { email });

      if (response.data.success) {
        setSuccess(true);
      }
    } catch (err) {
      console.error('Forgot password error:', err);
      setError(err.response?.data?.message || 'Failed to send reset link. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (success) {
    return (
      <div className="login-container">
        <div className="login-background">
          <div className="login-pattern"></div>
        </div>

        <div className="login-card">
          <div className="login-header">
            <div className="logo-container">
              <img
                src="/logo-full.png"
                alt="Bad Boy Bail Bonds"
                className="logo-image"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'block';
                }}
              />
              <div className="logo-text-fallback" style={{ display: 'none' }}>
                <h1 className="company-name">BAD BOY</h1>
                <h2 className="company-type">BAIL BONDS</h2>
              </div>
            </div>
            <p className="login-subtitle">Password Reset</p>
          </div>

          <div className="success-message">
            <div className="success-icon">✓</div>
            <h3>Check Your Email</h3>
            <p>If an account exists with the email <strong>{email}</strong>, you will receive a password reset link shortly.</p>
            <p className="help-text">Please check your inbox and spam folder.</p>
          </div>

          <Link to="/login" className="btn btn-secondary btn-block">
            <FaArrowLeft /> Back to Login
          </Link>

          <div className="login-footer">
            <p className="copyright">
              © 2025 Bad Boy Bail Bonds - Montana Pretrial Services LLC
            </p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="login-container">
      <div className="login-background">
        <div className="login-pattern"></div>
      </div>

      <div className="login-card">
        <div className="login-header">
          <div className="logo-container">
            <img
              src="/logo-full.png"
              alt="Bad Boy Bail Bonds"
              className="logo-image"
              onError={(e) => {
                e.target.style.display = 'none';
                e.target.nextSibling.style.display = 'block';
              }}
            />
            <div className="logo-text-fallback" style={{ display: 'none' }}>
              <h1 className="company-name">BAD BOY</h1>
              <h2 className="company-type">BAIL BONDS</h2>
            </div>
          </div>
          <p className="login-subtitle">Forgot Your Password?</p>
        </div>

        <p className="help-text" style={{ marginBottom: '1.5rem', textAlign: 'center' }}>
          Enter your email address and we'll send you a link to reset your password.
        </p>

        <form onSubmit={handleSubmit} className="login-form">
          {error && (
            <div className="alert alert-error">
              <span className="alert-icon">⚠️</span>
              {error}
            </div>
          )}

          <div className="form-group">
            <label htmlFor="email">Email Address</label>
            <input
              type="email"
              id="email"
              name="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email address"
              required
              autoFocus
              disabled={loading}
            />
          </div>

          <button
            type="submit"
            className="btn btn-primary btn-login"
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner-small"></span>
                Sending...
              </>
            ) : (
              'Send Reset Link'
            )}
          </button>
        </form>

        <div className="login-links">
          <Link to="/login" className="link-secondary">
            <FaArrowLeft /> Back to Login
          </Link>
        </div>

        <div className="login-footer">
          <p className="copyright">
            © 2025 Bad Boy Bail Bonds - Montana Pretrial Services LLC
          </p>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
